import { Component } from '@angular/core';

@Component({
  selector: 'ziro-site-management',
  templateUrl: './site-management.component.html',
  styleUrls: ['../../admin-page.scss'],
  standalone: false,
})
export class SiteManagementComponent {}
